import gsap from "gsap";

function initAnimation() {
	gsap.from(".segments__item", {
		duration: 3,
		ease: "power4.out",
		opacity: "0",
		stagger: 0.1,
	});
}

window.addEventListener("load", () => {
	initAnimation();
});
